import { AdminAccessNotice } from "@/components/admin/access-notice";
import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/app-layout";
import { useIsAdmin } from "@/hooks/use-is-admin";
import { ImageInputsPanel } from "@/components/admin/image-inputs-panel";
import { Loader2, ShieldOff } from "lucide-react";

export const Route = createFileRoute("/admin/settings")({
  component: AdminSettingsPage,
  head: () => ({
    meta: [
      { title: "Platform Settings — AskBell Admin" },
      {
        name: "description",
        content: "Admin controls for how AskBell prepares large pictures and other inputs before a background job runs.",
      },
      { property: "og:title", content: "Platform Settings — AskBell Admin" },
      { property: "og:description", content: "Tune how AskBell shrinks oversized pictures before sending them to a job." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});

function AdminSettingsPage() {
  const { isAdmin, loading, error: accessError, retry: retryAccess } = useIsAdmin();

  return (
    <AppLayout>
      <div className="flex-1 min-h-0 overflow-y-auto">
        <div className="mx-auto w-full max-w-3xl p-6">
          <h1 className="text-ui-2xl font-bold">Platform settings</h1>
          <p className="mt-1 text-ui-base text-muted-foreground">
            Controls that apply to everyone using AskBell.
          </p>

          <div className="mt-6">
            {loading ? (
              <div className="flex items-center gap-2 text-muted-foreground">
                <Loader2 className="h-4 w-4 animate-spin" /> Checking access…
              </div>
            ) : !isAdmin ? (
              <AdminAccessNotice error={accessError} retry={retryAccess} />
            ) : (
              <ImageInputsPanel />
            )}
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
